import React from 'react';
import Navbar from '../lab/Navbar';
import Sidebar from '../lab/Sidebar';
import Footer from '../lab/Footer';
import WalletContent from './WalletContent';
import './css/Wallet.css';

const Wallet = ({ isCollapsed, toggleSidebar }) => {
    return (
        <div className='lab-container'>
            <Navbar />
            <WalletContent />
            <Footer />
        </div>
    );
};

export default Wallet;
